<script setup lang="ts">
  type Density = 'default' | 'comfortable' | 'compact'

  const props = withDefaults(
    defineProps<{
      modelValue: unknown | null
      items: Array<string | number | Record<string, any>>
      label?: string
      color?: string
      density?: Density
      clearable?: boolean
      disabled?: boolean
      placeholder?: string
      itemTitle: string | null
      itemValue: string | null
      returnObject?: boolean
    }>(),
    {
      label: '',
      color: 'primary',
      density: 'comfortable',
      clearable: false,
      disabled: false,
      placeholder: '',
      itemTitle: null,
      itemValue: null,
      returnObject: false
    }
  )

  const emit = defineEmits<{
    (e: 'update:modelValue', value: unknown | null): void
    (e: 'change', value: unknown | null): void
  }>()

  function onUpdate(value: unknown | null) {
    emit('update:modelValue', value)
    emit('change', value)
  }
</script>

<template>
  <v-select
    :items="items"
    :model-value="modelValue"
    @update:modelValue="onUpdate"
    :item-title="itemTitle"
    :item-value="itemValue"
    :return-object="returnObject"
    :label="label"
    :color="color"
    :density="density"
    :clearable="clearable"
    :disabled="disabled"
    :placeholder="placeholder"
    hide-details
  />
</template>

<style scoped></style>
